<ng-container *ngIf="loading">
  <div class="table" id="object-information">
    <div class="table-row">
      <div class="table-column blue">Информация об объекте</div>
      <!-- <div class="table-column blue" *ngIf="userName !== 'MioUser' && (object.city.id === 0 || object.city.id === null)">
        <span class="mio-radio">
          <input type="radio" name="selector" type="radio" [(ngModel)]="object.portalID" [value]="1">
          <label for="">МИО</label>
        </span>
        <span>
          <input type="radio" name="selector" type="radio" [(ngModel)]="object.portalID" [value]="2">
          <label for="">БД</label>
        </span>
      </div> -->
      <div class="table-column blue">ID {{ object?.out_id }}</div>
      <div class="button-column">
        <div class="button-logs" (click)="downloadReport()">
          Отчет
        </div>
        <div class="button-logs" (click)="logModal = true" *ngIf="
            (user.roles | userRole: 'MioAdministrator') ||
            (user.roles | userRole: 'MioRegionAdministrator') ||
            (user.roles | userRole: 'BDAdmin')
          ">
          Логирование
        </div>
      </div>
    </div>
    <ng-container>
      <div class="table-row">
        <div class="table-column required">
          <i [ngClass]="!object.name ? 'error' : ''">1</i> Наименование объекта
        </div>
        <div class="table-column">
          <div class="name" *ngIf="!objectNameLoading">
            {{ object.name }}
          </div>
          <ng-container *ngIf="objectNameLoading">
            <textarea  class="form-control" type="text" [(ngModel)]="object.name" (keyup)="changeObjectName(object.name)"
              ></textarea>
              <!-- (keyup)="changeObjectName(object.name)"></textarea>  (keydown)="setFieldValue('objectNameLoading', $event)"-->
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="editObjectName()"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column required">
          <i [ngClass]="object.city.id === 0 || object.city.id === null ? 'error' : ''">2</i> Область / Город
        </div>
        <div class="table-column">
          <ng-container *ngIf="object.city">
            <ng-container
            *ngIf="object?.region
            && object.region.name !== citiesEnum.almaty
            && object.region.name !== citiesEnum.shymkent
            && object.region.name !== citiesEnum.nursultan">
              {{ object.region.name }}
              <div class="slash">/</div>
            </ng-container>
            <ng-container>{{ object.city.name }}</ng-container>
          </ng-container>
          <ng-container *ngIf="!object.city">-</ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-list" (click)="cityModal = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.latitude && !object.longitude ? 'error' : ''">3</i>
          Месторасположение
        </div>
        <div class="table-column" *ngIf="object.latitude && object.longitude">Объект привязан</div>
        <div class="table-column icon-column">
          <ng-container *ngIf="object.latitude != 0 && object.longitude != 0">
            <span (click)="openMapDialog()" class="icon-location"></span>
          </ng-container>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]=" object.developer?.private_partner?.bin === null ? 'error' : ''">4</i>
          Частный партнер
        </div>
        <div class="table-column">
          <ng-container *ngIf=" object.developer?.private_partner?.bin !== null">
            {{ object.developer?.private_partner?.title }}
          </ng-container>
        </div>
        <div class="table-column icon-column" (click)="openDeveloperModal('private_partner')">
          <span class="icon-list"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="file6 === null? 'error' : ''">5</i> Договор
        </div>
        <div class="table-column">
          <ng-container>
            <ng-container *ngIf="contract === false">
              <ng-container *ngIf="!docLog">
                <ng-container *ngIf="documentNumber !== 0 && documentNumber !== 'null'">
                  <span class="doc-number">
                    № {{documentNumber}}
                  </span>
                </ng-container>
                <ng-container *ngIf="documentNumber == 0 || documentNumber == 'null'">
                  <span class="doc-number">
                    № -
                  </span>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="docLog">
                №<input class="form-control" type="text" [(ngModel)]="documentNumber"
                  (keydown)="setFieldValue('docLog', $event)" placeholder="-" />
              </ng-container>
            </ng-container>
            <div class="docs-file" *ngFor="let doc of object.docs;">
              <ng-container *ngIf="contract === true && doc.documentTypeID === 6">
                <ng-container *ngIf="!docLog">
                  <ng-container *ngIf="doc.documentNumber !== 0 && doc.documentNumber !== 'null'">
                    <span class="doc-number">№ {{doc.documentNumber}}</span>
                  </ng-container>
                  <ng-container *ngIf="doc.documentNumber == 0 || doc.documentNumber == 'null'">
                    <span class="doc-number">
                      № -
                    </span>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="docLog">
                  №<input class="form-control" type="text" [(ngModel)]="doc.documentNumber"
                    (keydown)="setFieldValue('docLog', $event)" placeholder="-" />
                </ng-container>
              </ng-container>
              <ng-container>
                <!-- <a *ngIf="doc.documentTypeID === 6" class="link" (click)="downloadDocument(doc.dbFileID, doc.fileName)">{{ doc.fileName }}</a> -->
                  <a *ngIf="doc.documentTypeID === 6" [attr.href]="
                  api + 'LivingComplexes/DownloadDocument?fileID=' + doc.dbFileID">{{doc.fileName }}</a>
                </ng-container>
              <ng-container *ngIf="doc.documentTypeID === 6">
                <span class="item-close" (click)="deleteDocument(doc.dbFileID)"></span>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="findDocByTypeId(6) == null && object.id != 0">
            Выберите PDF документ
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <ng-container>
            <!-- <span class="icon-save">
            <input type="file" (change)="uploadDocument($event.target.files, 1)" />
          </span> -->
            <span class="icon-edit" (click)="docLog = true"></span>
            <span class="attach-icon">
              <img src="./assets/svg-icons/attach.svg" />
              <input type="file" accept="application/pdf" [disabled]="documentNumber === 0" (change)="uploadDocument($event, 6)"
                multiple />
            </span>
          </ng-container>
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="object.landPlotTypeID !== null || object.cadastral !== null ? '' : 'error'">6</i>Земельный участок
        </div>
        <div class="table-column">
          <label class="container" (click)="landPlotTypeBtn(false)">Собственность
            <input [(ngModel)]="object.landPlotTypeID" type="radio" [value]="1" name="radio">
            <span class="checkmark"></span>
          </label>
          <label class="container" (click)="landPlotTypeBtn(true)">Аренда
            <input [(ngModel)]="object.landPlotTypeID" type="radio" [value]="2" name="radio">
            <span class="checkmark"></span>
          </label>
          <span *ngIf="object.leaseExpDate !== null">{{getDate(object.leaseExpDate)}}</span>
          <span *ngIf="object.leaseExpDate === null">-</span>
        </div>
        <div class="table-column icon-column">
          <button class="icon-calendar calendar-1" [ngStyle]="landPlotType?{'color':'#217AD8'}:''"
            [disabled]="!landPlotType" (click)="landPlotTypeCalendar = true"></button>
        </div>
      </div>
      <div class="table-row cadastral-row">
        <div class="table-column cadastral-column">
          Кадастровый номер
        </div>
        <div class="table-column cadastral-column cadastral-input">
          <ng-container *ngIf="!cadastralToggle">
            <ng-container *ngIf="!object.cadastral">-</ng-container>
            <ng-container *ngIf="object.cadastral">
              {{object.cadastral}}</ng-container>
          </ng-container>
          <ng-container *ngIf="cadastralToggle">
            <input class="form-control" type="text" [(ngModel)]="object.cadastral"
              (keydown)="setFieldValue('cadastralToggle', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="cadastralToggle = true"></span>
        </div>
      </div>
      <!--новая экспертиза-->

      <div class="table-row">
        <app-new-expertises
          [livingComplexID]="object.id"
          [regionID]="object?.region?.id"
          [objectName]="object.name"
          [btnIsActive]="expertiseBtnIsActive"></app-new-expertises>
      </div>

      <!--<div class="table-row">
        <div class="table-column">
          <i [ngClass]="file1 === null? 'error' : ''">7</i> Заключение государственной экспертизы
        </div>
        <div class="table-column">
          <ng-container *ngIf="findDocByTypeId(1) != null">
            <div class="docs-file" *ngFor="let doc of object.docs">
              &lt;!&ndash; <a *ngIf="doc.documentTypeID === 1" class="link" (click)="downloadDocument(doc.dbFileID, doc.fileName)">{{ doc.fileName }}</a> &ndash;&gt;
              <a *ngIf="doc.documentTypeID === 1" [attr.href]="api + 'LivingComplexes/DownloadDocument?fileID=' + doc.dbFileID">{{doc.fileName }}</a>
              <ng-container *ngIf="doc.documentTypeID === 1">
                <span class="item-close" (click)="deleteDocument(doc.dbFileID)"></span>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="findDocByTypeId(1) == null && object.id != 0">
            Выберите PDF документ
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <ng-container>
            &lt;!&ndash; <span class="icon-save">
            <input type="file" (change)="uploadDocument($event.target.files, 1)" />
          </span> &ndash;&gt;
            <span class="attach-icon">
              <img src="./assets/svg-icons/attach.svg" />
              <input type="file" accept="application/pdf" (change)="uploadDocument($event.target.files, 1)" multiple />
            </span>
          </ng-container>
        </div>
      </div>-->

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="file2 === null? 'error' : ''">8</i> Талон о приеме уведомления о начале СМР
        </div>
        <div class="table-column">
          <ng-container *ngIf="findDocByTypeId(2) != null">
            <div *ngFor="let doc of object.docs">
              <!-- <a *ngIf="doc.documentTypeID === 2" class="link" (click)="downloadDocument(doc.dbFileID, doc.fileName)">{{ doc.fileName }}</a> -->
              <a *ngIf="doc.documentTypeID === 2" [attr.href]="
                api + 'LivingComplexes/DownloadDocument?fileID=' + doc.dbFileID">{{doc.fileName }}</a>
              <ng-container *ngIf="doc.documentTypeID === 2">
                <span class="item-close" (click)="deleteDocument(doc.dbFileID)"></span>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="findDocByTypeId(2) == null && object.id != 0">
            Выберите PDF документ
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <ng-container>
            <!-- <span class="icon-save">
            <input type="file" (change)="uploadDocument($event.target.files, 1)" />
          </span> -->
            <span class="attach-icon">
              <img src="./assets/svg-icons/attach.svg" />
              <input type="file" accept="application/pdf" (change)="uploadDocument($event, 2)" multiple />
            </span>
          </ng-container>
        </div>
      </div>


      <div class="table-row">
        <div class="table-column required">
          <i [ngClass]="!object.development_start_date ? 'error' : ''">9</i> Дата
          начала СМР
        </div>
        <div class="table-column">
          <ng-container *ngIf="object.development_start_date != null">{{
            getDate(object.development_start_date)
            }}</ng-container>
          <ng-container *ngIf="object.development_start_date == null">-</ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-calendar" (click)="startCalendarModal = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column required">
          <i [ngClass]="!object.duration ? 'error' : ''">10</i> Нормативная
          продолжительность строительства, мес.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!durationLoading">
            <ng-container *ngIf="object.duration != 0">{{
              object.duration
              }}</ng-container>
            <ng-container *ngIf="object.duration == 0">-</ng-container>
          </ng-container>
          <ng-container *ngIf="durationLoading">
            <input class="form-control" type="number" [(ngModel)]="object.duration"
              (keydown)="setFieldValue('durationLoading', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column" *ngIf="object.development_start_date !== null">
          <span class="icon-edit" (click)="durationLoading = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.duration ? 'error' : ''">11</i>Дата
          завершения СМР
        </div>
        <div class="table-column">
          <ng-container *ngIf="object.development_start_date != null">{{
            object.duration
            ? getPlus9Month(object.development_start_date, object.duration)
            : ""
            }}</ng-container>
          <ng-container *ngIf="object.development_start_date == null">-</ng-container>
        </div>
        <div class="table-column icon-column">
          <!-- <span class="icon-edit" (click)="countOfFlats1 = true"></span> -->
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="object.delayEndDate === null? 'error' : ''">12</i>
          Дата завершения СМР с учетом продления сроков строительства (согласно Дополнительному соглашению)
        </div>
        <div class="table-column">
          <span>
            <ng-container *ngIf="object.delayEndDate != null">{{
              getDate(object.delayEndDate)
              }}</ng-container>
            <ng-container *ngIf="object.delayEndDate == null">-</ng-container>
          </span>
          <span class="doc12">
            <ng-container *ngIf="findDocByTypeId(7) != null">
              <div class="docs-file" *ngFor="let doc of object.docs">
                <!-- <a *ngIf="doc.documentTypeID === 7" class="link" (click)="downloadDocument(doc.dbFileID, doc.fileName)">{{ doc.fileName }}</a> -->
                <a *ngIf="doc.documentTypeID === 7" [attr.href]="api + 'LivingComplexes/DownloadDocument?fileID=' + doc.dbFileID">{{doc.fileName }}</a>
                <ng-container *ngIf="doc.documentTypeID === 7">
                  <span class="item-close" (click)="deleteDocument(doc.dbFileID)"></span>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="findDocByTypeId(7) == null && object.id != 0">
              Выберите PDF документ
            </ng-container>
          </span>
        </div>
        <div class="table-column icon-column">
          <span class="icon-calendar" (click)="delayModal = true"></span>
          <span class="attach-icon" [ngClass]="object.delayEndDate === null?'withoutData': ''">
            <img src="./assets/svg-icons/attach.svg" />
            <input type="file" accept="application/pdf" [disabled]="object.delayEndDate === null"
              (change)="uploadDocument($event, 7)" multiple />
          </span>
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="object.buildingDocumentsCount === 0 ? 'error' : ''">13</i> Акт приёмки объекта в
          эксплуатацию
        </div>
        <div class="table-column">
          <button class="btn-act" (click)="actModal = true" *ngIf="object.buildingDocumentsCount !== 0 ">
            Скачать
          </button>
        </div>
        <div class="table-column icon-column">
          <!-- <span class="icon-list" (click)="actModal = true"></span> -->
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.estimateCost ? 'error' : ''">14</i>
          Сметная стоимость строительства, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!estimateCost">
            <ng-container *ngIf="object.estimateCost=== 0">-</ng-container>
            <ng-container *ngIf="object.estimateCost !== 0">{{
              object.estimateCost | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="estimateCost">
            <input class="form-control" type="text" [(ngModel)]="object.estimateCost"
              (keydown)="setFieldValue('estimateCost', $event)" placeholder="-" />
          </ng-container>
          <div class="info-wrapper" *ngIf="object.kenmlAmount && checkKenmlAmount">
            <div class="info-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.99952 0C8.85617 0 10.6368 0.737551 11.9496 2.0504C13.2625 3.36325 14 5.14385 14 7.0005C14 8.85715 13.2625 10.6378 11.9496 11.9506C10.6368 13.2634 8.85617 14.001 6.99952 14.001C5.14288 14.001 3.36227 13.2634 2.04942 11.9506C0.736574 10.6378 -0.000976562 8.85715 -0.000976562 7.0005C-0.000976563 5.14385 0.736574 3.36325 2.04942 2.0504C3.36227 0.737551 5.14288 0 6.99952 0ZM8.04952 4.298C8.56952 4.298 8.99152 3.937 8.99152 3.402C8.99152 2.867 8.56852 2.506 8.04952 2.506C7.52952 2.506 7.10952 2.867 7.10952 3.402C7.10952 3.937 7.52952 4.298 8.04952 4.298ZM8.23252 9.925C8.23252 9.818 8.26952 9.54 8.24852 9.382L7.42652 10.328C7.25652 10.507 7.04352 10.631 6.94352 10.598C6.89815 10.5813 6.86023 10.549 6.83658 10.5068C6.81293 10.4646 6.80511 10.4154 6.81452 10.368L8.18452 6.04C8.29652 5.491 7.98852 4.99 7.33552 4.926C6.64652 4.926 5.63252 5.625 5.01552 6.512C5.01552 6.618 4.99552 6.882 5.01652 7.04L5.83752 6.093C6.00752 5.916 6.20552 5.791 6.30552 5.825C6.35479 5.84268 6.39516 5.87898 6.41797 5.92609C6.44078 5.97321 6.44421 6.02739 6.42752 6.077L5.06952 10.384C4.91252 10.888 5.20952 11.382 5.92952 11.494C6.98952 11.494 7.61552 10.812 8.23352 9.925H8.23252Z"
                  fill="#E6A400"/>
              </svg>
            </div>
            <div class="tooltip">
              <div class="tooltip-value border">
                <div class="icon-svg">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.99952 0C8.85617 0 10.6368 0.737551 11.9496 2.0504C13.2625 3.36325 14 5.14385 14 7.0005C14 8.85715 13.2625 10.6378 11.9496 11.9506C10.6368 13.2634 8.85617 14.001 6.99952 14.001C5.14288 14.001 3.36227 13.2634 2.04942 11.9506C0.736574 10.6378 -0.000976562 8.85715 -0.000976562 7.0005C-0.000976563 5.14385 0.736574 3.36325 2.04942 2.0504C3.36227 0.737551 5.14288 0 6.99952 0ZM8.04952 4.298C8.56952 4.298 8.99152 3.937 8.99152 3.402C8.99152 2.867 8.56852 2.506 8.04952 2.506C7.52952 2.506 7.10952 2.867 7.10952 3.402C7.10952 3.937 7.52952 4.298 8.04952 4.298ZM8.23252 9.925C8.23252 9.818 8.26952 9.54 8.24852 9.382L7.42652 10.328C7.25652 10.507 7.04352 10.631 6.94352 10.598C6.89815 10.5813 6.86023 10.549 6.83658 10.5068C6.81293 10.4646 6.80511 10.4154 6.81452 10.368L8.18452 6.04C8.29652 5.491 7.98852 4.99 7.33552 4.926C6.64652 4.926 5.63252 5.625 5.01552 6.512C5.01552 6.618 4.99552 6.882 5.01652 7.04L5.83752 6.093C6.00752 5.916 6.20552 5.791 6.30552 5.825C6.35479 5.84268 6.39516 5.87898 6.41797 5.92609C6.44078 5.97321 6.44421 6.02739 6.42752 6.077L5.06952 10.384C4.91252 10.888 5.20952 11.382 5.92952 11.494C6.98952 11.494 7.61552 10.812 8.23352 9.925H8.23252Z"
                      fill="#E6A400"/>
                  </svg>
                </div>
                <strong>Стоимость материалов превышает сметную!</strong>
              </div>
              <div class="tooltip-value">
                <div class="icon-svg"></div>
                <div class="tooltip-value__bottom">
                  <span>Стоимость материалов:</span><br/>
                  <b>{{ object.kenmlAmount | numberWithSpaces }} ₸</b>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="estimateCost = true"></span>
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i
            [ngClass]="calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv,object.bdInvCost_AddExp) === 0 &&  calculateParagh(object.ppInvCost_ConstrWork,object.ppInvCost_TechnicalSuperv,object.ppInvCost_AuthorSuperv, object.ppInvCost_AddExp) === 0 ? 'error' : ''">15</i>
          <strong>Общая сумма инвестиций по договору, тг.:</strong>
        </div>
        <div class="table-column">
          <ng-container
            *ngIf="calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv,object.bdInvCost_AddExp) + calculateParagh(object.ppInvCost_ConstrWork,object.ppInvCost_TechnicalSuperv,object.ppInvCost_AuthorSuperv, object.ppInvCost_AddExp) ===0">
            -</ng-container>
          <ng-container
            *ngIf="calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv,object.bdInvCost_AddExp) + calculateParagh(object.ppInvCost_ConstrWork,object.ppInvCost_TechnicalSuperv,object.ppInvCost_AuthorSuperv, object.ppInvCost_AddExp)!==0">{{
            calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv, object.bdInvCost_AddExp)
            +
            calculateParagh(object.ppInvCost_ConstrWork,object.ppInvCost_TechnicalSuperv,object.ppInvCost_AuthorSuperv, object.ppInvCost_AddExp)
            | numberWithSpaces
            }}</ng-container>
        </div>
        <div class="table-column icon-column"></div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i
            [ngClass]="calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv) === 0 ? 'error' : ''">16</i>
          <strong>Сумма инвестиций по договору за счет средств АО "Казахстанская жилищная компания", тг.:</strong>
        </div>
        <div class="table-column">
          <ng-container
            *ngIf="calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv,object.bdInvCost_AddExp) === 0">
            -</ng-container>
          <ng-container
            *ngIf=" calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv,object.bdInvCost_AddExp) !== 0">{{
            calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv,object.bdInvCost_AddExp)
            | numberWithSpaces
            }}</ng-container>
        </div>
        <div class="table-column icon-column"></div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.bdInvCost_ConstrWork ? 'error' : ''">16.1</i>
          Стоимость СМР, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!bdInvCost_ConstrWork">
            <ng-container *ngIf="object.bdInvCost_ConstrWork=== 0">-</ng-container>
            <ng-container *ngIf="object.bdInvCost_ConstrWork !== 0">{{
              object.bdInvCost_ConstrWork | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="bdInvCost_ConstrWork">
            <input class="form-control" type="text" [(ngModel)]="object.bdInvCost_ConstrWork"
              (keydown)="setFieldValue('bdInvCost_ConstrWork', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="bdInvCost_ConstrWork = true"></span>
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.bdInvCost_TechnicalSuperv ? 'error' : ''">16.2</i>
          Стоимость технического надзора, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!bdInvCost_TechnicalSuperv">
            <ng-container *ngIf="object.bdInvCost_TechnicalSuperv=== 0">-</ng-container>
            <ng-container *ngIf="object.bdInvCost_TechnicalSuperv !== 0">{{
              object.bdInvCost_TechnicalSuperv | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="bdInvCost_TechnicalSuperv">
            <input class="form-control" type="text" [(ngModel)]="object.bdInvCost_TechnicalSuperv"
              (keydown)="setFieldValue('bdInvCost_TechnicalSuperv', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="bdInvCost_TechnicalSuperv = true"></span>
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.bdInvCost_AuthorSuperv ? 'error' : ''">16.3</i>
          Стоимость авторского надзора, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!bdInvCost_AuthorSuperv">
            <ng-container *ngIf="object.bdInvCost_AuthorSuperv=== 0">-</ng-container>
            <ng-container *ngIf="object.bdInvCost_AuthorSuperv !== 0">{{
              object.bdInvCost_AuthorSuperv | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="bdInvCost_AuthorSuperv">
            <input class="form-control" type="text" [(ngModel)]="object.bdInvCost_AuthorSuperv"
              (keydown)="setFieldValue('bdInvCost_AuthorSuperv', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="bdInvCost_AuthorSuperv = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.bdInvCost_AddExp ? 'error' : ''">16.4</i>
          Стоимость дополнительных расходов, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!bdInvCost_AddExp">
            <ng-container *ngIf="object.bdInvCost_AddExp === 0">-</ng-container>
            <ng-container *ngIf="object.bdInvCost_AddExp !== 0">{{
              object.bdInvCost_AddExp | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="bdInvCost_AddExp">
            <input class="form-control" type="text" [(ngModel)]="object.bdInvCost_AddExp"
              (keydown)="setFieldValue('bdInvCost_AddExp', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="bdInvCost_AddExp = true"></span>
        </div>
      </div>


      <div class="table-row">
        <div class="table-column">
          <i
            [ngClass]="calculateParagh(object.ppInvCost_ConstrWork,object.ppInvCost_TechnicalSuperv,object.ppInvCost_AuthorSuperv) === 0 ? 'error' : ''">17</i>
          <strong>Сумма инвестиций по договору за счет средств Частного партнера, тг.:</strong>
        </div>
        <div class="table-column">
          <ng-container
            *ngIf="calculateParagh(object.ppInvCost_ConstrWork,object.ppInvCost_TechnicalSuperv,object.ppInvCost_AuthorSuperv,object.ppInvCost_AddExp) === 0">
            -</ng-container>
          <ng-container
            *ngIf="calculateParagh(object.ppInvCost_ConstrWork,object.ppInvCost_TechnicalSuperv,object.ppInvCost_AuthorSuperv,object.ppInvCost_AddExp) !== 0">{{
            calculateParagh(object.ppInvCost_ConstrWork,object.ppInvCost_TechnicalSuperv,object.ppInvCost_AuthorSuperv,object.ppInvCost_AddExp)
            | numberWithSpaces
            }}</ng-container>
        </div>
        <div class="table-column icon-column"></div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.ppInvCost_ConstrWork ? 'error' : ''">17.1</i>
          Стоимость СМР, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!ppInvCost_ConstrWork">
            <ng-container *ngIf="object.ppInvCost_ConstrWork=== 0">-</ng-container>
            <ng-container *ngIf="object.ppInvCost_ConstrWork !== 0">{{
              object.ppInvCost_ConstrWork | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="ppInvCost_ConstrWork">
            <input class="form-control" type="text" [(ngModel)]="object.ppInvCost_ConstrWork"
              (keydown)="setFieldValue('ppInvCost_ConstrWork', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="ppInvCost_ConstrWork = true"></span>
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.ppInvCost_TechnicalSuperv ? 'error' : ''">17.2</i>
          Стоимость технического надзора, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!ppInvCost_TechnicalSuperv">
            <ng-container *ngIf="object.ppInvCost_TechnicalSuperv=== 0">-</ng-container>
            <ng-container *ngIf="object.ppInvCost_TechnicalSuperv !== 0">{{
              object.ppInvCost_TechnicalSuperv | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="ppInvCost_TechnicalSuperv">
            <input class="form-control" type="text" [(ngModel)]="object.ppInvCost_TechnicalSuperv"
              (keydown)="setFieldValue('ppInvCost_TechnicalSuperv', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="ppInvCost_TechnicalSuperv = true"></span>
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.ppInvCost_AuthorSuperv ? 'error' : ''">17.3</i>
          Стоимость авторского надзора, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!ppInvCost_AuthorSuperv">
            <ng-container *ngIf="object.ppInvCost_AuthorSuperv=== 0">-</ng-container>
            <ng-container *ngIf="object.ppInvCost_AuthorSuperv !== 0">{{
              object.ppInvCost_AuthorSuperv | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="ppInvCost_AuthorSuperv">
            <input class="form-control" type="text" [(ngModel)]="object.ppInvCost_AuthorSuperv"
              (keydown)="setFieldValue('ppInvCost_AuthorSuperv', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="ppInvCost_AuthorSuperv = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.ppInvCost_AddExp ? 'error' : ''">17.4</i>
          Стоимость дополнительных расходов, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!ppInvCost_AddExp">
            <ng-container *ngIf="object.ppInvCost_AddExp=== 0">-</ng-container>
            <ng-container *ngIf="object.ppInvCost_AddExp !== 0">{{
              object.ppInvCost_AddExp | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="ppInvCost_AddExp">
            <input class="form-control" type="text" [(ngModel)]="object.ppInvCost_AddExp"
              (keydown)="setFieldValue('ppInvCost_AddExp', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="ppInvCost_AddExp = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.guarantObligationPercent ? 'error' : ''">18</i>
          Гарантийное обязательство, %
        </div>
        <div class="table-column">
          <ng-container *ngIf="!guarantObligationPercent">
            <ng-container *ngIf="object.guarantObligationPercent=== 0">-</ng-container>
            <ng-container *ngIf="object.guarantObligationPercent !== 0">{{
              object.guarantObligationPercent | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="guarantObligationPercent">
            <input class="form-control" type="text" [(ngModel)]="object.guarantObligationPercent"
              (keydown)="setFieldValue('guarantObligationPercent', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="guarantObligationPercent = true"></span>
        </div>
      </div>


      <div class="table-row">
        <div class="table-column">
          <i
            [ngClass]="calculatePercent(object.bdInvCost_ConstrWork, object.guarantObligationPercent)  === 0 ? 'error' : ''">19</i>
          Гарантийная сумма, тг.
        </div>
        <div class="table-column">
          <ng-container>
            <ng-container *ngIf="calculatePercent(object.bdInvCost_ConstrWork, object.guarantObligationPercent) === 0">-
            </ng-container>
            <ng-container *ngIf="calculatePercent(object.bdInvCost_ConstrWork, object.guarantObligationPercent) !== 0">{{
              calculatePercent(object.bdInvCost_ConstrWork, object.guarantObligationPercent) | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <!-- <ng-container *ngIf="guarantObligationPercent">
                  <input class="form-control" type="text" [(ngModel)]="object.guarantObligationPercent" (keydown)="setFieldValue('guarantObligationPercent', $event)"
                    placeholder="-" />
                </ng-container> -->
        </div>
        <div class="table-column icon-column">
          <!-- <span class="icon-edit" (click)="guarantObligationPercent = true"></span> -->
        </div>
      </div>



      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="calculate(object.bD_FlatArea,object.pP_FlatArea)  === 0 ? 'error' : ''">20</i>
          <strong>Общая площадь квартир, кв.м.:</strong>
        </div>
        <div class="table-column">
          <ng-container *ngIf="calculate(object.bD_FlatArea,object.pP_FlatArea) === 0">-</ng-container>
          <ng-container *ngIf="calculate(object.bD_FlatArea,object.pP_FlatArea) !== 0">{{
            calculate(object.bD_FlatArea,object.pP_FlatArea) | numberWithSpaces
            }}</ng-container>
        </div>
        <div class="table-column icon-column"></div>
      </div>



      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.bD_FlatArea ? 'error' : ''">20.1</i>
          Площадь квартир (АО "Казахстанская жилищная компания"), кв.м.:
        </div>
        <div class="table-column">
          <ng-container *ngIf="!bD_FlatArea">
            <ng-container *ngIf="object.bD_FlatArea=== 0">-</ng-container>
            <ng-container *ngIf="object.bD_FlatArea !== 0">{{
              object.bD_FlatArea | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="bD_FlatArea">
            <input class="form-control" type="text" [(ngModel)]="object.bD_FlatArea"
              (keydown)="setFieldValue('bD_FlatArea', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="bD_FlatArea = true"></span>
        </div>
      </div>



      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.pP_FlatArea ? 'error' : ''">20.2</i>
          Площадь квартир (Частный партнер), кв.м.:
        </div>
        <div class="table-column">
          <ng-container *ngIf="!pP_FlatArea">
            <ng-container *ngIf="object.pP_FlatArea=== 0">-</ng-container>
            <ng-container *ngIf="object.pP_FlatArea !== 0">{{
              object.pP_FlatArea | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="pP_FlatArea">
            <input class="form-control" type="text" [(ngModel)]="object.pP_FlatArea"
              (keydown)="setFieldValue('pP_FlatArea', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="pP_FlatArea = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="calculate(object.bD_FlatCount, object.pP_FlatCount) === 0 ? 'error' : ''">21</i>
          <strong>Общее количество квартир, ед.:</strong>
        </div>
        <div class="table-column">
          <ng-container *ngIf="calculate(object.bD_FlatCount, object.pP_FlatCount)  === 0">-</ng-container>
          <ng-container *ngIf="calculate(object.bD_FlatCount, object.pP_FlatCount) !== 0">{{
            calculate(object.bD_FlatCount, object.pP_FlatCount) | numberWithSpaces
            }}</ng-container>
        </div>
        <div class="table-column icon-column"></div>
      </div>


      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.bD_FlatCount ? 'error' : ''">21.1</i>
          Количество квартир (АО "Казахстанская жилищная компания"), ед.:
        </div>
        <div class="table-column">
          <ng-container *ngIf="!bD_FlatCount">
            <ng-container *ngIf="object.bD_FlatCount=== 0">-</ng-container>
            <ng-container *ngIf="object.bD_FlatCount !== 0">{{
              object.bD_FlatCount | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="bD_FlatCount">
            <input class="form-control" type="text" [(ngModel)]="object.bD_FlatCount"
              (keydown)="setFieldValue('bD_FlatCount', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="bD_FlatCount = true"></span>
        </div>
      </div>



      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.pP_FlatCount ? 'error' : ''">21.2</i>
          Количество квартир (Частный партнер), ед.:
        </div>
        <div class="table-column">
          <ng-container *ngIf="!pP_FlatCount">
            <ng-container *ngIf="object.pP_FlatCount=== 0">-</ng-container>
            <ng-container *ngIf="object.pP_FlatCount !== 0">{{
              object.pP_FlatCount | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="pP_FlatCount">
            <input class="form-control" type="text" [(ngModel)]="object.pP_FlatCount"
              (keydown)="setFieldValue('pP_FlatCount', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="pP_FlatCount = true"></span>
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.investments.implementation_amount ? 'error' : ''">22</i>
          Плановая себестоимость 1 кв.м. квартиры, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!implementationAmountLoading">
            <ng-container *ngIf="object.investments.implementation_amount === 0">-</ng-container>
            <ng-container *ngIf="object.investments.implementation_amount !== 0">{{
              object.investments.implementation_amount | numberWithSpaces : 'toFixed'
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="implementationAmountLoading">
            <input class="form-control" type="text" [(ngModel)]="object.investments.implementation_amount" (keydown)="setFieldValue('implementationAmountLoading', $event)" placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="implementationAmountLoading = true"></span>
        </div>
      </div>
      <!-- <div class="table-row">
        <div class="table-column">
          <i [ngClass]="object.bD_FlatArea === null || object.bD_FlatArea === 0? 'error' : ''">22</i>
          Себестоимость 1 кв.м. (АО "Казахстанская жилищная компания"), тг.:
        </div>
        <div class="table-column">
          <ng-container>
            <ng-container
              *ngIf="calculateCostprice(calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv),object.bD_FlatArea) === 0 && object.bD_FlatArea === null">
              -</ng-container>
            <ng-container
              *ngIf="calculateCostprice(calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv),object.bD_FlatArea)  !== 0 && object.bD_FlatArea !== null">
              {{calculateCostprice(calculateParagh(object.bdInvCost_ConstrWork,object.bdInvCost_TechnicalSuperv,object.bdInvCost_AuthorSuperv),object.bD_FlatArea)}}</ng-container>
          </ng-container>

        </div>
        <div class="table-column icon-column">
        </div>
      </div> -->

      <div class="table-row">
        <div class="table-column">
          <i
            [ngClass]="object.livingComplexFactFlatArea === 0 || object.livingComplexFactFlatArea === null ? 'error' : ''">23</i>
          Общая фактическая площадь квартир АО "Казахстанская жилищная компания" (согласно техническим паспортам квартир), кв.м.:
        </div>
        <div class="table-column">
          <ng-container>
            <ng-container *ngIf="object.livingComplexFactFlatArea=== 0">-</ng-container>
            <ng-container *ngIf="object.livingComplexFactFlatArea !== 0">{{
              object.livingComplexFactFlatArea | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <!-- <ng-container *ngIf="bD_FlatArea">
                <input class="form-control" type="text" [(ngModel)]="object.bD_FlatArea" (keydown)="setFieldValue('bD_FlatArea', $event)"
                  placeholder="-" />
              </ng-container> -->
        </div>
        <div class="table-column icon-column">
          <!-- <span class="icon-edit" (click)="bD_FlatArea = true"></span> -->
        </div>
      </div>





      <!-- <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.investments.own_investments ? 'error' : ''">10</i>
          Плановая сумма инвестиций за счёт собственных средств МИО, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!ownInvestmentsLoading">
            <ng-container *ngIf="object.investments.own_investments === 0">-</ng-container>
            <ng-container *ngIf="object.investments.own_investments !== 0">{{
              object.investments.own_investments | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="ownInvestmentsLoading">
            <input class="form-control" type="text" [(ngModel)]="object.investments.own_investments" (keydown)="setFieldValue('ownInvestmentsLoading', $event)"
              placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="ownInvestmentsLoading = true"></span>
        </div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.investments.bd_investments ? 'error' : ''">11</i>
          Плановая сумма инвестиций за счёт средств облигационного займа АО
          "Казахстанская жилищная компания", тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!bdInvestmentsLoading">
            <ng-container *ngIf="object.investments.bd_investments === 0">-</ng-container>
            <ng-container *ngIf="object.investments.bd_investments !== 0">{{
              object.investments.bd_investments | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="bdInvestmentsLoading">
            <input class="form-control" type="text" [(ngModel)]="object.investments.bd_investments" (keydown)="setFieldValue('bdInvestmentsLoading', $event)"
              placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="bdInvestmentsLoading = true"></span>
        </div>
      </div> -->
      <!--
      <div class="table-row">
        <div class="table-column">
          <strong>
            Общая сумма инвестиций по договору (включая договора подряда,
            технического надзора, авторского надзора), тг.:
          </strong>
        </div>
        <div class="table-column">
          <ng-container *ngIf="
            object.investments.own_investments2 +
              object.investments.bd_investments2 ===
            0
          ">-</ng-container>
          <ng-container *ngIf="
            object.investments.own_investments2 +
              object.investments.bd_investments2 !==
            0
          ">
            {{
            calculate(
            object.investments.own_investments2,
            object.investments.bd_investments2
            ) | numberWithSpaces
            }}
          </ng-container>
        </div>
        <div class="table-column icon-column"></div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.investments.own_investments2 ? 'error' : ''">12</i>
          Сумма инвестиций по договору за счёт собственных средств МИО, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!ownInvestmentsLoading2">
            <ng-container *ngIf="object.investments.own_investments2 === 0">-</ng-container>
            <ng-container *ngIf="object.investments.own_investments2 !== 0">{{
              object.investments.own_investments2 | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="ownInvestmentsLoading2">
            <input class="form-control" type="text" [(ngModel)]="object.investments.own_investments2" (keydown)="setFieldValue('ownInvestmentsLoading2', $event)"
              placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="ownInvestmentsLoading2 = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.investments.bd_investments2 ? 'error' : ''">13</i>
          Сумма инвестиций по договору за счет средств облигационного займа АО
          "Казахстанская жилищная компания", тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!bdInvestmentsLoading2">
            <ng-container *ngIf="object.investments.bd_investments2 === 0">-</ng-container>
            <ng-container *ngIf="object.investments.bd_investments2 !== 0">{{
              object.investments.bd_investments2 | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="bdInvestmentsLoading2">
            <input class="form-control" type="text" [(ngModel)]="object.investments.bd_investments2" (keydown)="setFieldValue('bdInvestmentsLoading2', $event)"
              placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="bdInvestmentsLoading2 = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column"><i [ngClass]="this.object.investments.own_investments2 === 0 || this.object.investments.own_investments2 === null? 'error' : ''">14</i>
          Экономия</div>
        <div class="table-column">
          {{ calculateEconomy() | numberWithSpaces }}
        </div>
        <div class="table-column icon-column"></div>
      </div>
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="!object.investments.implementation_amount ? 'error' : ''">15</i>
          Плановая себестоимость 1 кв.м. квартиры, тг.
        </div>
        <div class="table-column">
          <ng-container *ngIf="!implementationAmountLoading">
            <ng-container *ngIf="object.investments.implementation_amount === 0">-</ng-container>
            <ng-container *ngIf="object.investments.implementation_amount !== 0">{{
              object.investments.implementation_amount | numberWithSpaces
              }}</ng-container>
          </ng-container>
          <ng-container *ngIf="implementationAmountLoading">
            <input class="form-control" type="text" [(ngModel)]="object.investments.implementation_amount" (keydown)="setFieldValue('implementationAmountLoading', $event)"
              placeholder="-" />
          </ng-container>
        </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="implementationAmountLoading = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column"><i [ngClass]="object.livingComplexFlatCount === 0 || object.livingComplexFlatCount === null ? 'error' : ''">16</i>
          Общее количество квартир, единиц</div>
        <div class="table-column-1 table-column">
          <div>
            <ng-container *ngIf="!countOfFlats">
              <ng-container *ngIf="object.livingComplexFlatCount === 0">-</ng-container>
              <ng-container *ngIf="object.livingComplexFlatCount !== 0">{{
                object.livingComplexFlatCount | numberWithSpaces
                }}</ng-container>
            </ng-container>
            <ng-container *ngIf="countOfFlats">
              <input class="form-control" type="number" [(ngModel)]="object.livingComplexFlatCount" (keydown)="setFieldValue('countOfFlats', $event)"
                placeholder="-" />
            </ng-container>
          </div>
          <div *ngIf="object.total_flat_count !== 0">
            /{{ object.total_flat_count }}
          </div>
          <div *ngIf="object.total_flat_count === 0">/-</div> -->
      <!-- <div class="all-plan2">общ. кол-во квартир</div> -->
      <!-- </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="countOfFlats = true"></span>
        </div>
      </div> -->
      <!--
    <div class="table-row">
      <div class="table-column"><i>17</i> Общее количество квартир, единиц</div>
      <div class="table-column-1 table-column">
        <div class="all-plan1" *ngIf="object.total_flat_count !== 0">{{object.total_flat_count}}</div>
        <div class="all-plan1" *ngIf="object.total_flat_count === 0">-</div>
        <div class="all-plan2">общ. кол-во квартир</div>
        <div class="all-plan2">
          <ng-container *ngIf="!countOfFlats">
            <ng-container *ngIf="object.livingComplexFlatCount === 0">-</ng-container>
            <ng-container *ngIf="object.livingComplexFlatCount !== 0">{{object.livingComplexFlatCount
              | numberWithSpaces}}</ng-container>
          </ng-container>
          <ng-container *ngIf="countOfFlats">
            <input class="form-control" type="number" [(ngModel)]="object.livingComplexFlatCount" (keydown)="setFieldValue('countOfFlats', $event)"
              placeholder="-" />

          </ng-container>
        </div>
      </div>
      <div class="table-column icon-column">
        <span class="icon-edit" (click)="countOfFlats = true"></span>
      </div>
    </div> -->
      <!--
      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="object.livingComplexFlatArea === 0 || object.livingComplexFlatArea === null ? 'error' : ''">17</i>
          Общая плановая площадь квартир, кв.м.
        </div>
        <div class="table-column-1 table-column">
          <div>
            <ng-container *ngIf="!countOfFlats1">
              <ng-container *ngIf="object.livingComplexFlatCount === 0">-</ng-container>
              <ng-container *ngIf="object.livingComplexFlatCount !== 0">{{
                object.livingComplexFlatArea | numberWithSpaces
                }}</ng-container>
            </ng-container>
            <ng-container *ngIf="countOfFlats1">
              <input class="form-control" type="number" [(ngModel)]="object.livingComplexFlatArea" (keydown)="setFieldValue('countOfFlats1', $event)"
                placeholder="-" />
            </ng-container>
          </div>
          <div *ngIf="object.total_flat_count !== 0">
            /{{ object.total_flat_area }}
          </div>
          <div *ngIf="object.total_flat_count === 0">/-</div> -->
      <!-- <div class="all-plan2">общ. кол-во кв.м.</div> -->
      <!-- </div>
        <div class="table-column icon-column">
          <span class="icon-edit" (click)="countOfFlats1 = true"></span>
        </div>
      </div>

      <div class="table-row">
        <div class="table-column">
          <i [ngClass]="object.livingComplexFactFlatArea === 0 || object.livingComplexFactFlatArea === null ? 'error' : ''">18</i>
          Общая фактическая площадь квартир (согласно техническим
          паспортам квартир), кв.м.
        </div>
        <div class="table-column">
          <ng-container>
            <ng-container *ngIf="object.livingComplexFactFlatArea != 0">{{
              object.livingComplexFactFlatArea
              }}</ng-container>
            <ng-container *ngIf="object.livingComplexFactFlatArea == 0 || object.livingComplexFactFlatArea == null">-</ng-container>
          </ng-container> -->
      <!-- <ng-container>
          <input class="form-control" type="number" [(ngModel)]="object.duration" (keydown)="setFieldValue('durationLoading', $event)"
            placeholder="-" />
        </ng-container> -->
      <!-- </div>
        <div class="table-column icon-column"> -->
      <!-- <span class="icon-edit" (click)="durationLoading = true"></span> -->
      <!-- </div>
      </div> -->
      <div class="table" id="developer-information">
        <div class="table-row">
          <div class="table-column">
            <i>24</i>
            Администратор программы
          </div>
          <div class="table-column">
            <ng-container>{{companyName}}</ng-container>
          </div>
          <div class="table-column icon-column">
          </div>
        </div>
        <div class="table-row">
          <div class="table-column blue">Сведения о застройщике</div>
          <div class="table-column"></div>
          <div class="table-column icon-column"></div>
        </div>
        <div class="table-row">
          <div class="table-column">
            <i [ngClass]="object.developer?.authorized_organization?.bin === null? 'error' : ''">25</i>
            Уполномоченная компания
          </div>
          <div class="table-column">
            <ng-container *ngIf="object.developer?.authorized_organization">
              {{object.developer?.authorized_organization?.title }}</ng-container>
          </div>
          <div class="table-column icon-column" (click)="openDeveloperModal('authorized_organization')">
            <span class="icon-list"></span>
          </div>
        </div>
        <div class="table-row">
          <div class="table-column required">
            <i [ngClass]="object.developer?.general_contractor?.bin === null? 'error' : ''">26</i>
            Подрядчик, БИН
          </div>
          <div class="table-column">
            <ng-container *ngIf="object.developer?.general_contractor?.bin">
              {{object.developer?.general_contractor?.title }},
              {{object.developer?.general_contractor?.bin }}
            </ng-container>
          </div>
          <div class="table-column icon-column" (click)="openDeveloperModal('general_contractor')">
            <span class="icon-list"></span>
          </div>
        </div>
        <div class="table-row">
          <div class="table-column required">
            <i [ngClass]="object.developer?.author_supervision?.bin === null ? 'error' : ''">27</i>
            Авторский надзор
          </div>
          <div class="table-column">
            <ng-container *ngIf="object.developer?.author_supervision">
              {{ object.developer?.author_supervision?.title }}
            </ng-container>
          </div>
          <div class="table-column icon-column" (click)="openDeveloperModal('author_supervision')">
            <span class="icon-list"></span>
          </div>
        </div>
        <div class="table-row">
          <div class="table-column required">
            <i [ngClass]="object.developer?.technical_supervision?.bin === null ? 'error' : ''">28</i>
            Технический надзор
          </div>
          <div class="table-column">
            <ng-container *ngIf="object.developer?.technical_supervision">
              {{object.developer?.technical_supervision?.title}}
            </ng-container>
          </div>
          <div class="table-column icon-column" (click)="openDeveloperModal('technical_supervision')">
            <span class="icon-list"></span>
          </div>
        </div>
        <div class="table-row">
          <div class="table-column">
            <i [ngClass]="!object.curators || object.curators && object.curators?.length === 0 ? 'error' : ''">29</i>
            Куратор от АО "Казахстанская жилищная компания"
          </div>
          <div class="table-column">
            <div>
              <div class="courator" *ngFor="let c of object.curators">
                {{ c.fullName }} |
                <span class="dept">({{ c.departmentTitle }})</span> <br />
                <span class="phone">{{ c.phoneNumber }}</span>
              </div>
            </div>
          </div>
          <div class="table-column icon-column" (click)="openDeveloperModal('curators')">
            <span class="icon-list"></span>
          </div>
        </div>
        <!-- <div class="table-row">
          <div class="table-column">
            <i [ngClass]="!object.developer.supervisor ? 'error' : ''">24</i>
            Супервайзер
          </div>
          <div class="table-column">
            <ng-container *ngIf="object.developer.supervisor">{{
              object.developer.supervisor.name
              }}</ng-container>
          </div>
          <div class="table-column icon-column" (click)="openDeveloperModal('curators')">
            <span class="icon-list"></span>
          </div>
        </div> -->
      </div>
    </ng-container>
  </div>



  <div class="spots">
    <div class="spots_row">
      <div class="commonly first">
        <div class="rectangle-realize">Реализация</div>
        <div class="rectangle-exploitation">Введено в эксплуатацию</div>
      </div>
      <!--[ngStyle]="{'background-color':getColor(obj.percent)}"-->
      <div class="spot-list" *ngFor="let obj of object.spots; let i = index">
        <div class="spot-body">
          <div class="" [ngClass]="getColor(obj.realisationPercent)" (click)="openCollapse(i)">
            <div class="pie-chart" *ngIf="obj.realisationPercent < 100 && obj.realisationPercent > 0">
              <app-pie-chart-2 [centerText]="obj.realisationPercent"></app-pie-chart-2>
            </div>
            <div class="w-150">
              Пятно {{ obj.number === "" ? "-" : obj.number }}
            </div>
            <div class="w-150">
              Всего квартир/кв.м.
              <span>{{
                obj.apartment_number === 0
                ? "-"
                : (obj.apartment_number | numberWithSpaces)
                }}/{{ obj.totalFlatArea | numberWithSpaces }}</span>
            </div>
            <div class="w-150">
              Остаток квартир/кв.м.
              <span>
                {{
                obj.residueFlatCount === 0
                ? "-"
                : (obj.residueFlatCount | numberWithSpaces)
                }}/{{ obj.totalFlatArea | numberWithSpaces }}
              </span>
            </div>
            <!-- <div class="f-1">Общая площадь, м2 {{obj.totalFlatArea === 0 ? '-' : obj.totalFlatArea | numberWithSpaces}}</div> -->
            <div class="f-1">
              Реализовано, тг.
              {{
                calculate(
                  object.investments.own_investments2,
                  object.investments.bd_investments2
                  )  === 0
              ? "-"
              : (     calculate(
                object.investments.own_investments2,
                object.investments.bd_investments2
                )/object.spots.length | numberWithSpaces)
              }}
            </div>
            <div class="spot_info remove">
              <span class="icon-delete" (click)="removeSpot(obj); $event.stopPropagation()"></span>
            </div>
          </div>
          <div class="spot-form" *ngIf="obj.isOpen">
            <app-spot-form-editor [spotObject]="obj" [livingComplexID]="object.id"
              [wallMaterialTypes_]="wallMaterialTypes" [buildingRoomTypes]="buildingRoomTypes"
              [buildingClasses]="buildingClasses">
            </app-spot-form-editor>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="btns">
    <ng-container *ngIf="!updateLoading">
      <div class="btn" [ngClass]="
          !mioReadOnlyUserFlag && object.id !== 0 ? 'btn-apply' : 'btn-cancel'
        " (click)="!mioReadOnlyUserFlag && object.id !== 0 ? addSpot() : ''">
        Добавить пятно
      </div>
      <div class="btn" [ngClass]="!mioReadOnlyUserFlag ? 'btn-apply' : 'btn-cancel'"
        (click)="!mioReadOnlyUserFlag ? setObject() : ''">
        Подтвердить
      </div>
      <div class="btn btn-cancel" (click)="cancel()">Отменить</div>
    </ng-container>
    <ng-container *ngIf="updateLoading">
      <div class="loading"></div>
    </ng-container>
  </div>

  <!-- DEVELOPERS -->
  <app-modal-window *ngIf="developerModal" [title]="developerModalTitle" [visible]="developerModal" [height]="600" [width]="1000" (close)="developerModal = $event">
    <app-select-item [activeItem]="object.developer ? object.developer[developerCurrentKey] : null" [activeCurators]="object.curators"
                     [key]="developerCurrentKey"
                     (selectItem)="updateDeveloperByKey($event)"
                     (selectCurator)="selectCurator($event)" (closed)="developerModal = false"> </app-select-item>
  </app-modal-window>

  <!-- CITIES -->
  <app-modal-window *ngIf="cityModal" [title]="'Выбор города'" [visible]="cityModal" [scrollbar]="false"
    (close)="cityModal = $event">
    <app-select-city [region]="object.region" [city]="object.city"
      (selectRegion)="object.region = $event; selectRegionAdmin($event)"
      (selectCity)="object.city = $event; cityModal = false; selectRegion()"></app-select-city>
  </app-modal-window>

  <!-- LOCATION -->
  <app-modal-window *ngIf="locationModal" [title]="'Геолокация'" [visible]="locationModal" [scrollbar]="false"
    (close)="locationModal = $event">
    <!--<agm-map [latitude]="object.latitude" [longitude]="object.longitude" [styles]="styles" [zoom]="mapZoom">
      <agm-marker *ngIf="object.latitude != 48.7346586 && object.longitude != 67.3090432" [latitude]="object.latitude"
        [longitude]="object.longitude"></agm-marker>
    </agm-map>-->
  </app-modal-window>

  <!-- START DATE -->
  <app-modal-window *ngIf="startCalendarModal" [title]="'Календарь'" [visible]="startCalendarModal"
    (close)="startCalendarModal = $event" [width]="1300" [scrollbar]="false">
    <app-calendar (outputDate)="
        object.development_start_date = $event; startCalendarModal = false
      " [inputDate]="object.development_start_date"></app-calendar>
  </app-modal-window>

  <!-- START DATE -->
  <app-modal-window *ngIf="landPlotTypeCalendar" [title]="'Календарь'" [visible]="landPlotTypeCalendar"
    (close)="landPlotTypeCalendar = $event" [width]="1300" [scrollbar]="false">
    <app-calendar (outputDate)="
        object.leaseExpDate = $event; landPlotTypeCalendar = false
      " [inputDate]="object.leaseExpDate"></app-calendar>
  </app-modal-window>

  <!-- Delay DATE -->
  <app-modal-window *ngIf="delayModal" [title]="'Календарь'" [visible]="delayModal" (close)="delayModal = $event"
    [width]="1300" [scrollbar]="false">
    <app-calendar (outputDate)="
        object.delayEndDate = $event; delayModal = false
      " [inputDate]="object.development_start_date"></app-calendar>
  </app-modal-window>

  <!-- END DATE -->
  <app-modal-window *ngIf="endCalendarModal" [title]="'Календарь'" [visible]="endCalendarModal"
    (close)="endCalendarModal = $event" [width]="1300" [scrollbar]="false">
    <app-calendar (outputDate)="
        object.development_end_date = $event; endCalendarModal = false
      " [inputDate]="object.development_end_date" [use]="'info'" [object]="object" [paramsID]="paramsID">
    </app-calendar>
  </app-modal-window>

  <app-modal-window *ngIf="logModal" [title]="'Логирование'" [visible]="logModal" (close)="logModal = $event"
    [width]="950" [scrollbar]="false">
    <app-log [object]="object"></app-log>
  </app-modal-window>
</ng-container>
<app-modal-window *ngIf="openConfirmDialog" [title]="'Удалить'" [visible]="openConfirmDialog"
  (close)="openConfirmDialog = $event" [width]="550" [height]="380">
  <div class="confirm">
    <div class="body">
      <div class="warning">
        <img src="assets/svg-icons/warning.svg" alt="" />
      </div>
      <div class="text main">
        Вы уверены, что хотите удалить
        <ng-container *ngIf="deleteType === 'spot'">пятно</ng-container>
        <ng-container *ngIf="deleteType !== 'spot'">файл</ng-container>?
      </div>
      <div class="text secondary">
        В случае выбора "ДА", дальнейшее восстановление
        <ng-container *ngIf="deleteType === 'spot'">пятна</ng-container>
        <ng-container *ngIf="deleteType !== 'spot'">файла</ng-container>
        невозможно!
      </div>
    </div>
    <div class="btns">
      <div class="btn btn-apply" (click)="acceptRemove('yes')">ДА</div>
      <div class="btn btn-cancel" (click)="acceptRemove('no')">НЕТ</div>
    </div>
  </div>
</app-modal-window>
<ng-container *ngIf="!loading">
  <div class="loading"></div>
</ng-container>

<app-modal-window *ngIf="actModal" [title]="'Акт ввода в эксплутацию'" [visible]="actModal" (close)="actModal = $event"
  [width]="800" [height]="400">
  <div>
    <div class="act-row" *ngFor="let spot of object.spots; let i = index">
      <div class="actDoc" *ngIf="spot.docs?.length > 0">Пятно {{ spot.number == "" ? "-" : spot.number }}</div>

      <!-- <div class="actDoc" *ngIf="spot.docs?.length === 0">
        <div class="attach-icon act">
          <div class="btn btn-act">Акт приёмки объекта в эксплуатацию</div>
          <input type="file" (change)="uploadSpotActDocument($event.target.files, 2, spot.id, i, spot)">
        </div>
      </div> -->
      <div class="actDoc" *ngIf="spot.docs?.length > 0">
        <div class="actDocName">
          <a [attr.href]="api+'BuildingFiles/DownloadFile?fileId='+spot.docs[0].dbFileID">{{spot.docs[0].fileName}}</a>
        </div>
        <div class="deleteBtn" *ngIf="spot.docs?.length > 0">
          <span class="icon-delete" (click)="deleteActDocument(spot.docs[0].dbFileID, spot.docs, spot)"></span>
        </div>
      </div>
      <div class="actDoc" *ngIf="spot.docs?.length > 0">{{spot.docs[0].documentDate}}</div>
      <!-- <div class="canlendarAct actDoc" *ngIf="spot.docs?.length > 0">
        <button *ngIf="spot.calendarActVis" [disabled]="!spot.disCalendar" [ngClass]="!spot.disCalendar? 'disCalendar': ''"
          class="icon-calendar" (click)="actCalendar = true"></button>
      </div> -->
    </div>
  </div>
</app-modal-window>
<!-- START DATE -->
<app-modal-window *ngIf="actCalendar" [title]="'Календарь'" [visible]="actCalendar" (close)="actCalendar = $event"
  [width]="1300" [scrollbar]="false">
  <app-calendar (outputDate)="
        spotDocDate = $event; actCalendar = false; sendActDate()" [inputDate]="object.development_start_date"></app-calendar>
</app-modal-window>

<app-modal-window [title]="''" [visible]="error409" (close)="error409 = $event" [width]="550" [height]="380">
  <div class="confirm">
    <div class="body">
      <div class="warning">
        <img src="assets/svg-icons/warning.svg" alt="">
      </div>
      <div class="text main"> Данные объекта были изменены другим пользователем. <br> Обновите страницу.</div>

    </div>
    <div class="btns">
      <div class="btn btn-apply" (click)="refreshPage()">Перезагрузить</div>
      <div class="btn btn-cancel" (click)="cancelRefresh()">Отменить</div>
    </div>
  </div>
</app-modal-window>
